import styled from "styled-components";
import {JackpotBetPrizeAmountContainerDefaultBox} from "./jp-bet-prize-amount.default.box";

export const JackpotBetPrizeAmountContainer777Box = styled(JackpotBetPrizeAmountContainerDefaultBox)`
  background: #BC3554;
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
`;
